import { CommonModal } from 'components/common';
import React, { useEffect, useRef, useState } from 'react';
import './selectListModal.css'
import { IoMdRadioButtonOn } from 'react-icons/io';
import StorageService from 'utils/StorageServices';
import { getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { getUser } from '_services';

const SelectListModal = (props) => {

    let { isOpen, closeModal = () => { }, onSubmit = () => { } } = props;
    const companyIdRef = useRef(StorageService.getCompanyId());
    const firmIdRef = useRef(StorageService.getFirmId());

    const [listArray, setListArray] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentData, setCurrentData] = useState({});
    const [search, setSearch] = useState('');

    const fetchUpdatedByData = async () => {
        setLoading(true);
        try {
            const response = await getUser({
                company_id: companyIdRef.current,
                offset: 1,
                limit: 100,
                search: search,
                firm_id: firmIdRef.current || ""
            });

            if (response?.responseCode === 200) {
                const users = response.data.user_list.map(user => ({
                    label: user.company_user_name,
                    value: user?.user_id._id,
                }));

                setListArray(users);
                setLoading(false);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const getDataVehicleGroupList = async () => {
        setLoading(true);
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                search: search,
                offset: 1,
                limit: 100
            }
            const res = await getVehicleGroupListData(object);
            if (res?.responseCode == 200) {
                let finalArray = res?.data?.vehicle_group_list?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                    }
                })
                setListArray(finalArray);
                setLoading(false);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (isOpen?.type === 'updated_user_id') {
            fetchUpdatedByData();
        }
        if (isOpen?.type === 'vehicle_group_id') {
            getDataVehicleGroupList();
        }
        if (isOpen?.data?.value) {
            setCurrentData(isOpen?.data)
        }
    }, [isOpen?.type, search])

    const propsSelectModal = {
        ...props,
    };

    const handleOnChange = async (data) => {
        setCurrentData(data);
        onSubmit({ [isOpen?.type]: data });
        closeModal(false);
    };

    return (
        <>
            <CommonModal {...propsSelectModal}>
                <div className="__modalSel_content">
                    <div className='__modalSel_search'>
                        <input
                            type="text"
                            placeholder='Search'
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>

                    <ul className='__modalSelListUl'>
                        {
                            listArray?.length > 0 ?
                                listArray?.map((item, index) => {
                                    return (
                                        <li className={currentData?.value === item.value ? `__modalSelListLi active` : `__modalSelListLi`} onClick={(e) => handleOnChange(item)}>
                                            <div className='__modalSelListFlx'>
                                                <IoMdRadioButtonOn />
                                                <span>{item.label}</span>
                                            </div>
                                        </li>
                                        // <li className={currentData?.value === item.value ? `_bidsList __modalSelListLi active` : `_bidsList __modalSelListLi`} key={index + "PLK1MN1" + item.value + item.label} onClick={(e) => handleOnChange(item)}>
                                        //     <div className='__modalSelListFlx'>
                                        //         <input
                                        //             className="form-check-input _avPointer"
                                        //             id={index + "PLKMN" + item.value + item.label}
                                        //             type="radio"
                                        //             name="currentData_vehicle_status"
                                        //             checked={currentData?.value === item.value}
                                        //             onChange={(e) => handleOnChange(item)}
                                        //         />
                                        //         <label htmlFor={index + "PLKMN" + item.value + item.label}>
                                        //             <span>{item.label}</span>
                                        //         </label>
                                        //     </div>
                                        // </li>
                                    )
                                }) :
                                (
                                    loading ?
                                        <li>
                                            <span style={{ display: 'flex', justifyContent: 'center' }}> Loading... </span>
                                        </li> :
                                        <li>
                                            <span style={{ display: 'flex', justifyContent: 'center' }}> No data found </span>
                                        </li>
                                )
                        }
                    </ul>
                </div>
            </CommonModal>
        </>
    )
}

export default SelectListModal